import { useEffect, useState } from "react";
import Cookies from "js-cookie";
import baseURL from "../../config/api";
import { MdEmail } from "react-icons/md";
import { BsFillTelephoneFill } from "react-icons/bs";
import { FaMapMarkerAlt } from "react-icons/fa";
import useGroup from "../../hook/useGroup";

const MemberList = () => {
    const token = Cookies.get("token-my-cdir");
    const { selectedGroupId }: any = useGroup();
    const groupName = Cookies.get("groupName-my-cdir") || "";
    const [group, setGroup] = useState<any>(null);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (selectedGroupId > 0) {
            setLoading(true);

            fetch(`${baseURL}group/${selectedGroupId}`, {
                headers: {
                    Authorization: `Bearer ${token?.toString()}`
                }
            })
                .then((res) => res.json())
                .then((data) => {
                    setGroup(data || null);
                    setLoading(false);
                })
                .catch((error) => {
                    console.error(error);
                    setGroup(null);
                    setLoading(false);
                });
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedGroupId]);

    const getAddress = (group: any) => {
        const addressParts = [
            group?.street,
            group?.street2,
            group?.city,
            group?.state,
            group?.country,
        ].filter(Boolean);

        const address = addressParts.join(", ");

        return group?.zip
            ? `${address} - ${group.zip}`
            : address;
    };

    return (
        <div className="min-h-screen py-10 px-4 xm:px-6 lg:px-10 xl:px-16">

            <div className="mb-10">
                <h1 className="text-3xl font-bold text-gray-800">
                    {groupName}
                </h1>
            </div>

            {loading ? (
                <div className="flex justify-center items-center h-[300px]">
                    <div className="animate-spin h-10 w-10 border-4 border-secondary border-t-transparent rounded-full" />
                </div>
            ) : group ? (

                <div className="bg-white rounded-3xl shadow-xl border p-6 md:p-10">

                    <div className="grid grid-cols-1 lg:grid-cols-3 gap-10">
                        <div className="flex flex-col items-center text-center">

                            <ImageWithLoader imagePath={group?.imagePath} />

                            <h2 className="mt-5 text-2xl font-semibold text-gray-800">
                                {group.name}
                            </h2>
                        </div>

                        <div className="lg:col-span-2 space-y-8">
                            <div className="flex items-start gap-4">
                                <div className="bg-blue-100 text-secondary p-3 rounded-xl">
                                    <FaMapMarkerAlt />
                                </div>
                                <div>
                                    <p className="text-sm text-gray-500">Address</p>
                                    <p className="text-gray-800 font-medium break-words">
                                        {getAddress(group)}
                                    </p>
                                </div>
                            </div>

                            <div className="flex items-start gap-4">
                                <div className="bg-green-100 text-green-600 p-3 rounded-xl">
                                    <BsFillTelephoneFill />
                                </div>
                                <div>
                                    <p className="text-sm text-gray-500">Phone</p>
                                    <p className="text-gray-800 font-medium">
                                        {group.phoneNumber}
                                    </p>
                                </div>
                            </div>

                            <div className="flex items-start gap-4">
                                <div className="bg-purple-100 text-purple-600 p-3 rounded-xl">
                                    <MdEmail />
                                </div>
                                <div>
                                    <p className="text-sm text-gray-500">Email</p>
                                    <p className="text-gray-800 font-medium break-words break-all">
                                        {group.emailAddress}
                                    </p>
                                </div>
                            </div>

                            <div className="flex items-start gap-4">
                                <div className="bg-orange-100 text-orange-600 p-3 rounded-xl">
                                    🌐
                                </div>
                                <div>
                                    <p className="text-sm text-gray-500">Website</p>
                                    <a
                                        href={
                                            group.website?.startsWith("http")
                                                ? group.website
                                                : `https://${group.website}`
                                        }
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="text-secondary font-medium break-words hover:underline break-all"
                                    >
                                        {group.website || "N/A"}
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            ) : (
                <div className="text-center text-gray-500 mt-20">
                    No Data Found
                </div>
            )}
        </div>
    );
};

export default MemberList;


type ImageWithLoaderProps = {
    imagePath: string
}

const ImageWithLoader = ({ imagePath }: ImageWithLoaderProps) => {
    const [loading, setLoading] = useState<boolean>(true);

    return (
        <div className="relative w-44 h-44 md:w-56 md:h-56">
            {
                loading && (
                    <div className="absolute inset-0 flex flex-col items-center justify-center rounded-2xl bg-gray-200 animate-pulse">
                        <div className="inline-block h-8 w-8 animate-spin rounded-full border-4 border-current border-r-transparent text-secondary"></div>
                        <span className="text-sm mt-2">Loading...</span>
                    </div>
                )
            }

            <img
                src={
                    imagePath
                        ? `${baseURL}commonFile/Get?name=${imagePath}`
                        : "/images/img_placeholder1.jpg"
                }
                alt="church"
                className={`w-44 h-44 md:w-56 md:h-56 rounded-2xl object-cover shadow-lg transition-opacity duration-300 ${loading ? "opacity-0" : "opacity-100"}`}
                onLoad={() => setLoading(false)}
                onError={(e: any) => {
                    e.target.src = "/images/img_placeholder1.jpg";
                    setLoading(false);
                }}
            />
        </div>
    );
}